/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetDatesFormats$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDatesFormatsRequest = createAction<PayloadData<void>>('GET_DATES_FORMATS__GET_DATES_FORMATS__REQUEST');
export const getDatesFormatsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_DATES_FORMATS__GET_DATES_FORMATS__SUCCESS');
export const getDatesFormatsFailure = createAction<PayloadData<Error, void, true>>('GET_DATES_FORMATS__GET_DATES_FORMATS__FAILURE');

export const getDatesFormatsActions = [
    getDatesFormatsRequest,
    getDatesFormatsSuccess,
    getDatesFormatsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDatesFormats = (config?: GetDatesFormats$Config) => {
    return {
        CALL_API: {
            types: getDatesFormatsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/dates-formats`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

